module.exports = __webpack_public_path__ + "img/addContent.4759e17b.png";